import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import { admin_cse } from "@/config/roles";
import { FeatureFlagEnum } from "@/features/feature-flag/constants";
import { FeatureGate } from "@/features/feature-flag/components/FeatureGate";
import { isAuthorized } from "@/utils/authToken";

import ChangePatientEmailCard from "./Admin/ChangePatientEmailCard";
import ChangePatientPracticeCard from "./Admin/ChangePatientPracticeCard";
import OverridePatientAutocharge from "./Admin/OverridePatientAutocharge";
import ResetPatientPasswordCard from "./Admin/ResetPatientPasswordCard";
import RestrictPatientSchedulingCard from "./Admin/RestrictPatientSchedulingCard";
import VerifyPatientEmailCard from "./Admin/VerifyPatientEmailCard";

const MemberProfileAdmin = (props) => {
  useEffect(() => {
    if (!isAuthorized(admin_cse)) {
      props.history.push("/app/home");
    }
  }, []);

  return (
    <div className="AdminTab">
      <div className="mt-3 mb-3">
        <ChangePatientEmailCard
          patientDetails={props.patientDetails}
          updateState={props.updateState}
        />
      </div>

      <div className="mb-3">
        <VerifyPatientEmailCard
          patientDetails={props.patientDetails}
          updateState={props.updateState}
        />
      </div>

      <div className="mb-3">
        <ResetPatientPasswordCard
          patientDetails={props.patientDetails}
          updateState={props.updateState}
        />
      </div>

      <div className="mb-3">
        <ChangePatientPracticeCard
          patientDetails={props.patientDetails}
          updateState={props.updateState}
        />
      </div>

      <div className="mb-3">
        <OverridePatientAutocharge
          patientDetails={props.patientDetails}
          selectedTabChangeHandler={props.selectedTabChangeHandler}
          updateState={props.updateState}
        />
      </div>

      <FeatureGate
        defaultFlagValue={false}
        disabledFallback={<></>}
        flagName={FeatureFlagEnum.restrictPatientScheduling}
      >
        <div className="mb-3" ref={props?.adminFocusRef}>
          <RestrictPatientSchedulingCard
            patientDetails={props.patientDetails}
            refetchDetails={props.refetchDetails}
          />
        </div>
      </FeatureGate>
    </div>
  );
};

export default withRouter(MemberProfileAdmin);
